export default __webpack_public_path__ + "static/media/darkTheme.163832df.svg";